// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qy3DTq6RnuYGFTDINzIq{flex-direction:column;flex:1;align-self:center;width:620px;max-width:calc(100% - 88px);margin:0 auto;display:flex}@media (min-width:992px){.qy3DTq6RnuYGFTDINzIq{width:760px}}.XGFhWuUruHsczFa0kxyt{justify-content:space-between;align-items:center;padding:64px 20px 0;display:flex}.slHz2AG13DsHzNiiNpcP{flex-direction:column;gap:4px;display:flex}.C0vU_OHkJCAt1VEvPCxJ{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `qy3DTq6RnuYGFTDINzIq`,
	"header": `XGFhWuUruHsczFa0kxyt`,
	"headerDetails": `slHz2AG13DsHzNiiNpcP`,
	"headerActions": `C0vU_OHkJCAt1VEvPCxJ`
};
export default ___CSS_LOADER_EXPORT___;
